import { Theme } from "@bluframe/blublocks"
import { Link as ReactRouterDomLink } from "react-router-dom"
import styled from "styled-components"

const Link = styled(ReactRouterDomLink)`
  color: ${({ theme }: { theme: Theme }) => theme.palette.primary.main};
  text-decoration: underline;

  &:hover,
  &:focus {
    color: ${({ theme }: { theme: Theme }) => theme.palette.primary.main};
    font-weight: 700;
  }
`

export default Link
